import Model from './Model';

/* eslint-disable camelcase */
type Props = {
    readonly id: number;
    readonly name: string;
    readonly country_code: string;
};
/* eslint-enable camelcase */

export default class PaymentCountry extends Model {
    public readonly id: number;
    public readonly countryCode: string;
    public readonly name: string;

    /* eslint-disable camelcase */
    constructor({ id, country_code, name }: Props) {
        super();
        this.name = name;
        this.id = id;
        this.countryCode = country_code;
    }
    /* eslint-enable camelcase */
}
